import { frontendURL } from '../../../helper/URLHelper';
import HistoryIndex from './pages/HistoryIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/historico-operacional'),
    alias: [frontendURL('accounts/:accountId/activity')],
    name: 'operational_history_index',
    component: HistoryIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
